<template>
    <div class="md-layout md-alignment-center-center">
        <toolbar class="md-layout md-layout-item md-size-100" title="Liste des produits" :isAdd="this.isToolbarAutorized('Administration')" @add="navigateTo({ name: 'product_Edit', params: { id: 0 } })" >
        </toolbar>

        <div class="md-layout md-layout-item md-size-90 ">
            <keywordsToolbar v-bind:keywords.sync="filter.keywords"  @search="onSearch" expandable="true" @expand="onExpand">
                <div class="md-layout md-layout-item md-size-50 md-small-size-90">
                    <div class="md-layout-item">
                        <field-category title="Catégorie" v-bind:item.sync="filter" property="categoryId" :defaultValue="null" sourceURI="sale/productcategories" :expand="false" :readonly="false" @md-selected="onFilterChanged" />
                    </div>
                    <div class="md-layout-item md-size-25">
                        <md-switch v-model="filter.actif" class="md-primary" @change="onFilterChanged" >Actif</md-switch>
                    </div>
                </div>
            </keywordsToolbar>
        </div>

        <md-content class="ProductItems md-scrollbar md-transparent md-layout md-layout-item md-size-90" >
            <switchLayout storageKey="SaleProductListLayout" class="md-layout md-size-100">
                <template #list>
                    <md-table md-card class="md-layout-item" >
                        <md-table-row>
                            <md-table-head>Nom</md-table-head>
                            <md-table-head>Titre</md-table-head>
                            <md-table-head>Prix</md-table-head>
                            <md-table-head class="md-medium-hide">Modifié par</md-table-head>
                            <md-table-head class="md-medium-hide">Modifié le</md-table-head>
                            <md-table-head class="md-medium-hide">Actif</md-table-head>
                        </md-table-row>
            
                        <md-table-row v-for="(item, index) in items" :index="index" :key="index" @click="navigateTo({ name: 'product_Item', params: { id: item.id } })">
                            <md-table-cell>
                                <span class="md-primary md-cursor-pointer " @click.stop="navigateOpenNew({ name: 'product_Item', params: { id: item.id } })" >{{item.name}}</span>                                
                            </md-table-cell>
                            <md-table-cell>{{ item.title }}</md-table-cell>
                            <md-table-cell>{{ item.price }}</md-table-cell>
                            <md-table-cell class="md-medium-hide">{{ item.modifiedBy }}</md-table-cell>
                            <md-table-cell class="md-medium-hide">{{ item.modifiedOn | YYYYMMDD }}</md-table-cell>
                            <md-table-cell class="md-medium-hide">
                                <md-icon v-if="item.isActive" class="md-primary">done</md-icon>
                            </md-table-cell>
                        </md-table-row>
                    </md-table>                
                </template>
                <template #card>
                    <md-card md-with-hover class="md-layout-item md-size-17 md-large-size-30 md-mediumcls-size-45 md-small-size-100" v-for="(item, index) in items" :index="index" :key="index" >
                        <div class="md-layout-item md-alignment-top-left" @click="navigateTo({ name: 'product_Item', params: { id: item.id } })">
                            <div class="md-layout-item ">
                                <md-card-header>
                                    <div class="md-layout-item md-size-20 md-xlarge-size-35">
                                        <md-avatar class="md-avatar-icon md-medium md-primary">
                                            <md-icon>qr_code_2</md-icon>
                                        </md-avatar>
                                    </div>
                                    <md-card-header-text class="md-title md-alignment-center-right">
                                        {{item.name}}
                                    </md-card-header-text>
                                </md-card-header>
                            </div>
        
                            <md-card-content  class="md-py-0">
                                <p class="md-layout-item ">
                                    <span class="md-subheading">Nom: </span>
                                    <span class="md-primary md-cursor-pointer " @click.stop="navigateOpenNew({ name: 'product_Item', params: { id: item.id } })" >{{item.name}}</span><br />
                                    <span class="md-subheading">Titre: </span>
                                    <span>{{item.title}}</span>
                                </p>
                                <div class="md-layout-item md-layout md-xlarge-size-100">
                                    <div class="md-layout-item md-size-60 md-xlarge-size-100">
                                        <span class="md-subheading">Prix: </span>
                                        <span>{{item.price}}</span>
                                    </div>
                                    <div class="md-layout-item md-size-40 md-xlarge-size-100 ">
                                        <div class="md-layout md-alignment-center-right">
                                            <span class="md-subheading">Actif: </span>
                                            <span>&nbsp;<md-icon v-if="item.isActive" class="md-primary">done</md-icon></span>
                                        </div>
                                    </div>
                                </div>
                                <p class="md-layout-item">
                                    <span class="md-subheading">Modifié par: </span><span class="md-caption">{{ item.modifiedBy }}</span><br />
                                    <span class="md-subheading">Modifié le: </span><span class="md-caption">{{ item.modifiedOn | YYYYMMDD }}</span>
                                </p>

                            </md-card-content>
                        </div>
                    </md-card>
                </template>
            </switchLayout>
        </md-content>

        <partialListNavigation v-if="range" v-bind:response.sync="response" @more="more" class="md-layout md-layout-item md-size-100" />
    </div>
</template>
<style scoped>
    .md-primary {
        color: var(--md-theme-default-primary);
    }
    .md-content.md-transparent {
        background-color: transparent !important;

    }    
    .md-content.ProductItems {
        max-height: 450px;
        overflow: auto;
    }    
</style>
<script>
    import baseToolbar from '@/components/toolbarBase.vue';
    import keywordsToolbar from '@/components/toolbarKeywordsList.vue'
    import partialListNavigation from '@/components/partialListNavigation.vue';
    import field_category from '@/components/field-select-wd.vue';
    import switchLayout from '@/components/switchLayout.vue';

    import { autorisationExtension } from '@/mixins/autorisationExtension.js';
    import { apiSaleProductExtension } from '@/mixins/apiSaleProductExtension.js';
    import { navigateRouteExtension } from '@/mixins/navigateRouteExtension.js';

    export default {
        name: 'productList',
        mixins: [autorisationExtension, apiSaleProductExtension, navigateRouteExtension],
        data: () => ({
            items: [],
            range: null,
            filter: { keywords: '', categoryId: null, actif: true },
            response: null,
        }),

        mounted:
            async function () {

                let filter = localStorage.getItem("SaleProductListFilter");
                if (filter) { this.filter = JSON.parse(filter); }

                await this.dataRead();
            },

        methods: {
            dataRead: async function () {

                localStorage.setItem("SaleProductListFilter", JSON.stringify(this.filter));

                let data = await this.SaleProductListWithFilter(this.filter, this.range, this.callback);
                if (data) {
                    this.items = data;
                }

            },
            callback: function (response) {
                this.response = response;
                this.range = $App.getRangeHeader(response);
            },
            more: function () {
                this.dataRead();
            },
            onSearch: function (e) {
                if(e){ this.filter.keywords = e; }
                else if(e === '') {
                    this.filter.keywords = e;
                    this.filter.categoryId = null;
                }

                this.range = null;
                this.dataRead();
            },
            onExpand: function(e){
            },
            onFilterChanged: function(e) {
                this.range = null;
                this.dataRead();
            },
        },

        components: {
            toolbar: baseToolbar,
            keywordsToolbar: keywordsToolbar,
            partialListNavigation: partialListNavigation,
            'field-category': field_category,
            switchLayout: switchLayout
        }
    };
</script>
